import { render, staticRenderFns } from "./ShopLists.vue?vue&type=template&id=e7c319a8&scoped=true"
import script from "./ShopLists.vue?vue&type=script&lang=js"
export * from "./ShopLists.vue?vue&type=script&lang=js"
import style0 from "./ShopLists.vue?vue&type=style&index=0&id=e7c319a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c319a8",
  null
  
)

export default component.exports